<template>
  <div class="wrapper">
    <highcharts v-if="chartOptions!=null" :options="chartOptions" ref="chartComponent"></highcharts>
  </div>
</template>

<script>
import {Chart} from 'highcharts-vue'
// import Highcharts from "highcharts";
// import exportingInit from "highcharts/modules/exporting";
import {mapState} from "vuex";

// exportingInit(Highcharts);

export default {
  name: 'PieChartWidget',

  components: {
    highcharts: Chart
  },

  props: {
    widgetData: Object
  },

  computed: {
    ...mapState(['chartRedrawCounter']),
  },

  data() {
    return {
      chartOptions: null
    }
  },

  methods: {
    requestData(requester) {
      requester.addChartRequest(this.dataCallback, this.widgetData.extname);
    },

    dataCallback(dto) {
      this.chartOptions = JSON.parse(dto.chartJSON)
    }

  },

  watch: {
    chartRedrawCounter: function () {
      if(this.$refs.chartComponent && this.$refs.chartComponent.chart) {
        this.$refs.chartComponent.chart.reflow()
        // console.log("Reflowing!")
      } else {
        // console.log("Not Reflowing!")
        // console.log(this.chartOptions)
      }
    }
  }

}
</script>

<style scoped>
.wrapper {
}
</style>
